<template>
  <b-card>
    <b-card-header>
      <h2>
        <feather-icon
          icon="EditIcon"
          size="16"
        />
        {{ $t("Routes.editCategory") }}
      </h2>
    </b-card-header>
    <b-card-body>
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <b-form
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
        <b-row>
            <b-col
              cols="12"
              md="12"
            >
              <b-form-group
                :label="$t('AppHelpDesk.categoryColumns.parentCategoria')"
                label-for="assigned"
              >
                <v-select
                  id="assigned"
                  v-model="categoria.categoriaPadreId"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="rutaMostrar"
                  :options="categories"
                  :reduce="(option) => option.ticketCategoriaId"
                  :disabled="!$can('write', 'MesaAyuda')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('AppHelpDesk.categoryColumns.name')"
                rules="required|max:256"
              >
                <b-form-group
                  :label="$t('AppHelpDesk.categoryColumns.name')"
                  label-for="name"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    v-model="categoria.nombre"
                    :disabled="!$can('write', 'MesaAyuda')"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('AppHelpDesk.categoryColumns.abbreviation')"
                rules="required|max:256"
              >
                <b-form-group
                  :label="$t('AppHelpDesk.categoryColumns.abbreviation')"
                  label-for="name"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    v-model="categoria.abreviatura"
                    :disabled="!$can('write', 'MesaAyuda')"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('AppHelpDesk.categoryColumns.slaHours')"
                rules="required|max:256"
              >
                <b-form-group
                  :label="$t('AppHelpDesk.categoryColumns.slaHours')"
                  label-for="name"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    v-model="categoria.slaHoras"
                    :disabled="!$can('write', 'MesaAyuda')"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <validation-provider
                #default="{ errors }"
                :name="$t('AppHelpDesk.categoryDescription')"
                rules="required|max:256"
              >
                <b-form-group
                  :label="$t('AppHelpDesk.categoryDescription')"
                  label-for="description"
                >
                  <b-form-textarea
                    id="description"
                    v-model="categoria.descripcion"
                    rows="3"
                    placeholder="La computadora no enciende, ademas de que se calienta mucho"
                    :disabled="!$can('write', 'MesaAyuda')"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row
            v-if="$can('write', 'MesaAyuda')"
            class="float-right mt-2 mb-2"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              <b-spinner
                v-if="edditingCategory"
                small
                class="mr-1"
              />
              {{ $t("Lists.Edit") }}
            </b-button>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormInput,
  BFormGroup,
  BRow,
  BCol,
  BFormTextarea,
  BFormInvalidFeedback,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import {
  required,
} from '@validations'
import vSelect from 'vue-select'
import router from '@/router'
import ticketService from '@/services/helpDesk.service'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import { ref, onMounted } from '@vue/composition-api'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BFormTextarea,
    BFormInvalidFeedback,
    BButton,
    BSpinner,
    vSelect,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  setup() {
    const edditingCategory = ref(false)
    const categories = ref([])
    const categoria = ref({
      ticketCategoriaId: 0,
      nombre: '',
      descripcion: '',
      categoriaPadreId: null,
      abreviatura: '',
      ruta: '',
      slaHoras: 0,
    })
    const resetTicketData = () => {
      categoria.value = {
        ticketCategoriaId: 0,
        nombre: '',
        descripcion: '',
        categoriaPadreId: null,
        abreviatura: '',
        ruta: '',
        slaHoras: 0,
      }
    }

    const {
      fetchCategorias,
      fetchCategoria,
      updateCategoria,
    } = ticketService()

    fetchCategorias({}, data => {
      categories.value = data.categorias
    })

    onMounted(() => {
      fetchCategoria(router.currentRoute.params.ticketCategoriaId, data => {
        categoria.value = data
      })
    })

    const {
      getValidationState,
    } = formValidation(resetTicketData)
    const onSubmit = () => {
      edditingCategory.value = true
      updateCategoria(categoria.value)
        .then(() => {
          edditingCategory.value = false
          router.push({ name: 'apps-categories-list' })
        })
        .catch(() => {
          edditingCategory.value = false
        })
    }
    return {
      categories,
      categoria,
      edditingCategory,
      getValidationState,
      onSubmit,
    }
  },

}

</script>
